import React from 'react'
import './quotes.css'
import AVTR1 from '../../assets/avatar1.jpeg'
import AVTR2 from '../../assets/avatar2.jpeg'
import AVTR3 from '../../assets/avatar3.jpeg'
import AVTR4 from '../../assets/avatar4.jpg'

// import Swiper core and required modules
import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';



const data = [
  {
    avatar: AVTR1,
    name: 'Prophet Muhammad (S.A.W)',
    title: 'The Final Messenger',
    quote: 'Be kind, for whenever kindness becomes part of something, it beautifies it. Whenever it is taken from something, it leaves it tarnished.'
  },
  {
    avatar: AVTR2,
    name: 'My Father',
    title: 'Life Mentor',
    quote: 'As you grow older you will face many challenges in life, just do your best. Laugh, love, live. Believe in yourself and never give up on your dreams.'
  },
  {
    avatar: AVTR3,
    name: 'Mufti Ismail Menk',
    title: 'Islamic Scholar',
    quote: 'Don\'t let past mistakes make you lose hope of achieving good. Some of those with the worst past have made a great future for themselves.'
  },
  {
    avatar: AVTR4,
    name: 'Steve Jobs',
    title: 'Visionary Leader',
    quote: 'Innovation distinguishes between a leader and a follower. Stay hungry, stay foolish, and never stop believing in the power of great ideas.'
  },
]


const Quotes = () => {
  return (
    <section id='quotes'>
      {/* Floating Background Elements */}
      <div className="quotes__floating-element"></div>
      <div className="quotes__floating-element"></div>
      
      {/* Section Header */}
      <div className="quotes__header">
        <span className="quotes__badge">Inspiration</span>
        <h2 className="quotes__main-title">Words That Guide Me</h2>
        <p className="quotes__subtitle">
          Wisdom from the people who have shaped my perspective and values
        </p>
      </div>

      <Swiper className="container quotes__container" 
      // install Swiper modules
      modules={[Pagination]} spaceBetween={40}
      slidesPerView={1}
      pagination={{ clickable: true }}>
        {
          data.map(({avatar, name, title, quote}, index) => {
            return (
              <SwiperSlide key={index} className="quotes">
                <div className="quote__content">
                  <div className="quote__icon">"</div>
                  <p className='rolemodel__quote'>{quote}</p>
                  <div className="rolemodel__info">
                    <div className="rolemodel__avatar">
                      <img src={avatar} alt={name} />
                    </div>
                    <div className="rolemodel__details">
                      <h5 className='rolemodel__name'>{name}</h5>
                      <small className='rolemodel__title'>{title}</small>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Quotes